import { Component, Input, NgModule, Directive, ContentChild, QueryList, forwardRef,
         AfterContentInit, ChangeDetectionStrategy, EventEmitter, Output, HostBinding, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { UxAppShellService } from '@eui/core';
import { BaseDirective } from '../../base.directive';
import { EuiButtonModule } from '../eui-button/eui-button.component';
import { EuiDropdownModule } from '../eui-dropdown/eui-dropdown.component';
import { EuiListModule } from '../eui-list/eui-list.module';
import { EuiIconModule } from '../atoms/eui-icon/eui-icon.module';
import { EuiLabelModule } from '../atoms/eui-label/eui-label.module';

@Component({
    selector: 'eui-buttons',
    templateUrl: './eui-buttons.component.html',
    styleUrls: ['./styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})

export class EuiButtonsComponent extends BaseDirective implements AfterContentInit {
    @Input() localMenuLabel: string;
    @Input() hasLocalMenu: true | false = false;
    @Input() isBookmarkable: true | false = false;
    @Input() isBookmarked: true | false = false;
    @Input() isPrintable: true | false = false;

    @Output() bookmarked: EventEmitter<any> = new EventEmitter();
    // tslint:disable:max-line-length
    @ContentChild(forwardRef(() => EuiButtonsActionsContentTagDirective), { static: false }) customActionsContent: QueryList<EuiButtonsActionsContentTagDirective>;
    @ContentChild(forwardRef(() => EuiButtonsLocalMenuContentTagDirective), { static: false }) customLocalMenuContent: QueryList<EuiButtonsLocalMenuContentTagDirective>;

    @HostBinding('class')
    get cssClasses() {
        return [
            super.getCssClasses('eui-buttons'),
        ].join(' ').trim();
    }

    public currentRoute: string;

    constructor ( public asService: UxAppShellService,
                  private router: Router ) {
        super();
        this.currentRoute = this._getCurrentUrl(this.router.url);
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.currentRoute = this._getCurrentUrl(event.url);
            }
        });
    }

    ngAfterContentInit() {
        if (!this.e2eAttr) {
            this.e2eAttr = 'eui-buttons';
        }
    }

    public onBookmarkToggle(event: Event) {
        this.isBookmarked = !this.isBookmarked;
        this.bookmarked.emit({ isBookmarked: this.isBookmarked, url: this.currentRoute });
    }

    public onPrint(event: Event) {
        window.print();
    }

    private _getCurrentUrl(currentRoute: string) {
        return window.location.origin + currentRoute;
    }
}

/* tslint:disable */
@Directive({ selector: 'euiButtonsActionsContent' })
export class EuiButtonsActionsContentTagDirective { }

@Directive({ selector: 'euiButtonsLocalMenuContent' })
export class EuiButtonsLocalMenuContentTagDirective { }
/* tslint:enable */

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        EuiButtonModule,
        EuiDropdownModule,
        EuiIconModule,
        EuiLabelModule,
        EuiListModule,
    ],
    declarations: [
        EuiButtonsComponent,
        EuiButtonsActionsContentTagDirective,
        EuiButtonsLocalMenuContentTagDirective,
    ],
    exports: [
        EuiButtonsComponent,
        EuiButtonsActionsContentTagDirective,
        EuiButtonsLocalMenuContentTagDirective,
    ],
})
export class EuiButtonsModule { }
